import { AnalyticsHooks } from '@frontend/analytics-shared';
import { useScopedAppFlagStore } from '@frontend/scope';
import { featureFlags } from '../../../feature-flags';

interface Props {
  roi: 'appointment-reminders' | 'bulk-texting' | 'missedCallText' | 'noShowRate';
}

export const useHasRoiFeature = ({ roi }: Props) => {
  const { isIntegratedOffice } = AnalyticsHooks.useIsIntegratedOffice();
  const { getCustomizationFlagValue, getFeatureFlagValue } = useScopedAppFlagStore();

  let isFeatureEnabled = false;

  switch (roi) {
    case 'appointment-reminders':
    case 'bulk-texting': {
      isFeatureEnabled = true;
      break;
    }

    case 'noShowRate': {
      isFeatureEnabled = !getFeatureFlagValue(featureFlags.hideNoShowRate);
      break;
    }

    case 'missedCallText': {
      isFeatureEnabled = getCustomizationFlagValue('missedcalltext');
      break;
    }
  }

  return {
    isFeatureEnabled: !!isIntegratedOffice && isFeatureEnabled,
  };
};
